import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="relative pt-8 md:pt-12 pb-32 px-4 overflow-hidden" data-id="element-59" data-mp="9ipbb96819z2">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-green-900/20 via-background to-background -z-10" data-id="element-60" data-mp="4n9zsnvorq5t" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12 md:items-center" data-id="element-61" data-mp="x9uqdm4c7y8b">
        {/* Left column: headline, subheadline, CTA (desktop) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center md:text-left" data-id="element-62" data-mp="sd4d16jx3gql">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 leading-tight" style={{
          fontSize: "20px"
        }} data-id="element-63" data-mp="384s62qvt8p44">
            Tired of Being Tired?
            <br data-id="element-64" data-mp="3o73og9djvq70" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600" data-id="element-65" data-mp="3o5j39ad4ljlt">
              Obliterate Brain Fog and Reset Your High-Performance Operating
              System.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 mb-2 md:mb-10 max-w-2xl mx-auto md:mx-0 leading-relaxed" style={{
          fontSize: "14px",
          width: "340px"
        }} data-id="element-66" data-mp="30hhohjpct6xy">
            The Science-Backed Blueprint to Kill Distraction, Optimize Your Hormones, and Reclaim 100% of Your Potential. No Fluff. Just Biological Results.
          </p>

          {/* Desktop-only CTA + badge (mobile version sits below the image) */}
          <div className="hidden md:block" data-id="element-67" data-mp="2hk86m6zog1it">
            <Button href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="text-lg md:text-xl px-10 py-5 mb-8" data-id="element-68" data-mp="2hlj7nz1qmv68">
              RECLAIM MY EDGE FOR THE SECOND HALF →
            </Button>

            <p className="text-xs text-gray-500 tracking-wide mb-6" data-id="element-69" data-mp="naa0aponrglg">
              Instant Digital Download • PDF Format • Read on any device
            </p>

            <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-70" data-mp="dd5cymj2tf32">
              <ShieldCheck className="w-5 h-5 text-green-500 shrink-0" data-id="element-71" data-mp="dbaowzcid6ur" />
              <span data-id="element-72" data-mp="1b0du65c1o1z9">
                Join 2,400+ Professionals Optimizing Their Biology for a
                Powerful 2026 Finish
              </span>
            </div>
          </div>
        </motion.div>

        {/* Right column: bundle image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="flex justify-center" data-id="element-73" data-mp="x1edpkyoqte6">
          <img src="https://cdn.magicpatterns.com/uploads/gLSQe1J76oqZBuGM7qkkxs/Foto_para_Landing_page.png" alt="The Biologic Edge product bundle featuring The Brain Killer, The Biologic Edge manual, and The 7-Day Reset" className="w-full h-auto max-w-lg object-contain drop-shadow-[0_0_45px_rgba(80,200,120,0.45)]" style={{
          width: "330px",
          height: "200px"
        }} data-id="element-74" data-mp="1xacfx49qzltr" />
        </motion.div>

        {/* Mobile-only CTA + badge (appears below the image) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:hidden text-center" data-id="element-75" data-mp="2g2584wgzt30f">
          <Button href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="text-lg px-10 py-5 mb-8 w-full sm:w-auto" data-id="element-76" data-mp="umhfqh2m8tqz">
            RECLAIM MY EDGE FOR THE SECOND HALF →
          </Button>

          <p className="text-xs text-gray-500 tracking-wide mb-6" data-id="element-77" data-mp="4a2tti8kr5yk">
            Instant Digital Download • PDF Format • Read on any device
          </p>

          <div className="flex items-center justify-center gap-2 text-gray-400 text-sm font-medium" data-id="element-78" data-mp="e9jwdqsj53qb">
            <ShieldCheck className="w-5 h-5 text-green-500 shrink-0" data-id="element-79" data-mp="9ah1v0a6efwl" />
            <span data-id="element-80" data-mp="98e4twalvmid">
              Join 2,400+ Professionals Optimizing Their Biology for a Powerful
              2026 Finish
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}